export enum PromptTypes {
  AUTOMATIC = "automatic",
  MANUAL = "manual",
}

export default PromptTypes
